export default __webpack_public_path__ + "static/gtech-bd4b294202cb5d043265c2df3459b800.png";